import { Button } from "@/components/ui/button";
import { X, RotateCcw, MessageCircle } from "lucide-react";
import prontyAvatar from "@/assets/pronty-avatar.png";

interface ChatHeaderProps {
  onClose: () => void;
  onClear: () => void;
  sessionRemaining: number;
}

export function ChatHeader({ onClose, onClear, sessionRemaining }: ChatHeaderProps) {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b bg-primary text-primary-foreground rounded-t-2xl">
      <div className="flex items-center gap-3">
        <img src={prontyAvatar} alt="Pronty" className="w-9 h-9 rounded-full object-cover" />
        <div>
          <h3 className="font-semibold text-sm">Pronty</h3>
          <p className="text-xs text-primary-foreground/70">Assistente ProntuÁudio</p>
        </div>
      </div>

      <div className="flex items-center gap-1">
        <span className="text-xs text-primary-foreground/60 mr-2"></span>
        <Button
          variant="ghost"
          size="icon"
          onClick={onClear}
          className="h-8 w-8 text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/10"
          aria-label="Nova conversa"
        >
          <RotateCcw className="w-4 h-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="h-8 w-8 text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/10"
          aria-label="Fechar chat"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}

interface ChatToggleButtonProps {
  onClick: () => void;
  hasUnread?: boolean;
}

export function ChatToggleButton({ onClick, hasUnread }: ChatToggleButtonProps) {
  return (
    <Button
      onClick={onClick}
      size="lg"
      className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-105"
      aria-label="Abrir chat de suporte"
    >
      <MessageCircle className="w-6 h-6" />
      {hasUnread && <span className="absolute top-0 right-0 w-3 h-3 bg-destructive rounded-full animate-pulse" />}
    </Button>
  );
}
